import { render, staticRenderFns } from "./disclamerModeleAIM.vue?vue&type=template&id=87dbcd8e&scoped=true"
import script from "./disclamerModeleAIM.vue?vue&type=script&setup=true&lang=js"
export * from "./disclamerModeleAIM.vue?vue&type=script&setup=true&lang=js"
import style0 from "./disclamerModeleAIM.vue?vue&type=style&index=0&id=87dbcd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dbcd8e",
  null
  
)

export default component.exports